export default {
  HORIZONTAL: "orientation_HORIZONTAL",
  VERTICAL: "orientation_VERTICAL"
};
